const DEFAULT_PADDING_PX = 60;
const CONTEXT_ZOOM_LEVELS = 1;

/**
 * Fits a circle and then zooms out once so the public map also shows its area.
 */
export default function fitMapCircleWithContext(map, circle) {
	const bounds = circle?.getBounds?.();
	if (!map || !bounds) return;

	map.fitBounds(bounds, DEFAULT_PADDING_PX);
	google.maps.event.addListenerOnce(map, 'idle', () => {
		const fittedZoom = map.getZoom();
		if (Number.isFinite(fittedZoom)) {
			map.setZoom(Math.max(0, fittedZoom - CONTEXT_ZOOM_LEVELS));
		}
	});
}
